import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import ContactModal from 'Pods/Shared/ContactModal'
import Tooltip from 'Pods/Shared/Tooltip'

class ContactModalButton extends React.Component {
  constructor() {
    super()

    this.state = { contactModalIsOpen: false }

    this.toggleModal = this.toggleModal.bind(this)
  }

  toggleModal() {
    this.setState(prevState => ({
      contactModalIsOpen: !prevState.contactModalIsOpen,
    }))
  }

  render() {
    return (
      <Fragment>
        <Tooltip id={`product-support-${this.props.itemId}`} content="Product support">
          <button className="button button--icon" onClick={this.toggleModal}>
            <Icon type={['far', 'info-circle']} />
          </button>
        </Tooltip>
        {this.state.contactModalIsOpen && (
          <ContactModal
            modalIsOpen
            closeModal={this.toggleModal}
            itemId={this.props.itemId}
            authorUsername={this.props.authorUsername}
            conversationType="model_support"
            messagingForbidden={this.props.messagingForbidden}
          />
        )}
      </Fragment>
    )
  }
}

ContactModalButton.propTypes = {
  authorUsername: PropTypes.string.isRequired,
  itemId: PropTypes.number.isRequired,
  messagingForbidden: PropTypes.bool.isRequired,
}

export default ContactModalButton
